import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { RootStoresContext } from '../stores/RootStore';
import ChartPage from '../templates/ChartPage';
import HomePage from '../templates/HomePage';
import SearchPage from '../templates/SearchPage';
import StandardPage from '../templates/StandardPage';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import HeaderBanner, { HeaderBannerSearch } from './HeaderBanner/HeaderBanner';

const App: React.FC = () => {
  const rootStore = useContext(RootStoresContext);
  rootStore.appStore.checkVewPort();
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact={true} path={process.env.REACT_APP_BASE_PATH || ''}>
          <HeaderBannerSearch />
          <main id="main" className="main" role="main">
            <HomePage />
          </main>
          <Footer />
        </Route>
        <Route exact={true} path={`${process.env.REACT_APP_BASE_PATH || ''}/search`}>
          <HeaderBannerSearch />
          <main id="main" className="main" role="main">
            <SearchPage />
          </main>
          <Footer />
        </Route>
        <Route path={`${process.env.REACT_APP_BASE_PATH || ''}/phases/:phaseName?/:step?`}>
          <main id="main" className="main" role="main">
            <ChartPage />
          </main>
          <Footer />
        </Route>
        <Route path={`${process.env.REACT_APP_BASE_PATH || ''}/:pageName`}>
          <HeaderBanner />
          <main id="main" className="main" role="main">
            <StandardPage />
          </main>
          <Footer />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
